import axios from 'axios'

const articleTable = {
    state: {
        list: []
    },
    mutations: {
        SET_ARTICLE_LIST(state, payload) {
            state.list = payload
        },
    },
    actions: {
        fetchAllArticles: async ({
            commit
        }, status) => {

            const config = {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                }
            }

            try {
                const payload = await axios.get(`${process.env.VUE_APP_API}/article/all`, config)

                console.log(payload.data)

                commit('SET_ARTICLE_LIST', payload.data)

                return {
                    status: 200,
                    data: payload.data
                }
            } catch (error) {
                return {
                    status: 500,
                    error: error
                }
            }
        }
    },
    getters: {
        articleList: state => state.list
    }
}

export default articleTable